/**
 * Application Configuration - White Label Settings
 * 
 * This is the central place to configure all branding and application information.
 * Change these values to rebrand the application for different clients.
 */
export class EbmsVeeyaaConfig {
  public static config = {
    // ============================================
    // APPLICATION BRANDING - WHITE LABEL SETTINGS
    // ============================================
    // Change these values to rebrand the application
    
    // Application Names
    appName: 'EBMS',                                    // Short name (shown in navigation bar)
    appFullName: 'Everyday Beverages Management System', // Full application name
    appShortName: 'EBMS',                               // Abbreviated name
    appTitle: 'EBMS Employee - Beverages Management System', // Browser title
    
    // Company Information
    companyName: 'Veeyaa Innovatives',                   // Company name
    companyWebsite: 'https://veeyaainnovatives.com',              // Company website URL
    companyEmail: 'admin@veeyaainnovatives.com',                 // Support email
    companyPhone: '+1 234 567 8900',                   // Support phone
    
    // Application Details
    appVersion: '1.0.0',
    appDescription: 'Everyday Beverages Management System for managing operators, vendors, machines, and business operations',
    copyrightText: '© 2025 Veeyaa Innovatives. All rights reserved.',
    
    // Logo & Branding Assets
    logoPath: 'assets/images/ebms-logo.svg',           // Main logo (SVG recommended)
    logoIconPath: 'assets/images/logo-icon.png',       // Icon/thumbnail logo
    logoDarkPath: 'assets/images/logo-dark.png',       // Dark theme logo
    faviconPath: 'favicon.ico',                        // Favicon
    
    // User Agent (for API calls)
    userAgent: 'EBMS-Dashboard/1.0',                  // User agent string for external APIs
    
    // ============================================
    // LAYOUT CONFIGURATION
    // ============================================
    layout: 'vertical', // vertical, horizontal
    subLayout: '', // horizontal-2
    collapseMenu: false,
    layoutType: 'menu-dark', // menu-dark, menu-light, dark
    headerBackColor: 'header-blue', // header-default, header-blue, header-red, header-purple, header-info, header-dark
    navBrandColor: 'brand-default', // brand-default, brand-blue, brand-red, brand-purple, brand-info, brand-dark
    rtlLayout: false,
    navFixedLayout: true,
    headerFixedLayout: true,
    boxLayout: false,
  };
  
  /**
   * Get application name (short)
   */
  public static getAppName(): string {
    return this.config.appName;
  }
  
  /**
   * Get full application name
   */
  public static getAppFullName(): string {
    return this.config.appFullName;
  }
  
  /**
   * Get browser title
   */
  public static getAppTitle(): string {
    return this.config.appTitle;
  }
  
  /**
   * Get company name
   */
  public static getCompanyName(): string {
    return this.config.companyName;
  }
  
  /**
   * Get user agent string
   */
  public static getUserAgent(): string {
    return this.config.userAgent;
  }
}
